import React from 'react';
import { useSelector } from 'react-redux';
import { css } from '@emotion/core';

import {
    isMultiResultEntriesGames,
    isShowEntryResultEntryLists
} from 'config/promoGameTypesClientConfig';

import { routeContainerStyle } from 'client/styles/common';
import { isSmallPromoWidth } from 'config/promoGameTypes';

import usePromoSettingThemeStyle from 'hooks/useThemeStyleIntegration';
import usePromoSettingComponentStyle from 'hooks/usePromoSettingComponentStyle';

import ResultHeader from 'client/components/Result/ResultHeader';
import ResultFooter from 'client/components/Result/ResultFooter';
import GameCustomResult from 'client/components/Result/CustomResult/GameCustomResult';
import PopupParticipantJoinAndGetPrize from 'client/components/Result/PopupParticipantJoinAndGetPrize';
import ResultLotteryTask from 'client/components/Result/ResultLotteryTask';
import useResultPage from 'hooks/useResultPage';
import ResultPageFroalaView from 'components/ResultPage/ResultPageFroalaView';
import CustomResultList from 'client/components/Result/CustomResult/CustomResultList';
import { getCustomResultByGameType } from 'client/components/Result/CustomResult/CustomResultList';

function ResultPage() {
    const themeStyle = usePromoSettingThemeStyle();
    const componentStyle = usePromoSettingComponentStyle();
    const { type: gameType } = useSelector(s => s.promo);
    const { isMgmSelf } = useSelector(s => s.flags);
    const userGameResultRecords = useSelector(s => s.userGameResultRecords);
    const { userGameResultRecords: mgmUserGameResultRecords = [] } = useSelector(
        s => s.mgmReferral
    );
    const resultPage = useResultPage();
    const { sponsorSlotEnabled, sponsorSlotFroalaEditor } = resultPage;
    const latestRecord = userGameResultRecords[userGameResultRecords.length - 1];
    const { enableVerifyMechanism } = useSelector(s => s.settingPromo);
    const { Comp } = getCustomResultByGameType(gameType, Boolean(enableVerifyMechanism));
    const shouldShowCustomResult = isShowEntryResultEntryLists(gameType) && Boolean(Comp);
    const customResult = (
        <GameCustomResult
            gameResultPayload={latestRecord?.gameResult}
            latestRecord={latestRecord}
        />
    );
    return (
        <>
            <PopupParticipantJoinAndGetPrize />
            <div
                css={css([
                    routeContainerStyle,
                    wrapperStyle,
                    !isSmallPromoWidth(gameType) && { maxWidth: 'none' }
                ])}
            >
                <ResultHeader themeStyle={themeStyle} />
                {/* 活動結果頁：暫時隱藏總共獲得點數顯示 - https://app.clickup.com/t/866ahh78g 
                <ResultPoint promoUuid={promoUuid} themeStyle={themeStyle} /> */}
                {shouldShowCustomResult && (
                    <CustomResultList
                        items={
                            isMultiResultEntriesGames(gameType)
                                ? userGameResultRecords
                                : userGameResultRecords.slice(-1)
                        }
                        gameType={gameType}
                        componentStyle={componentStyle}
                        showFullList={isMultiResultEntriesGames(gameType)}
                        hasCustomResult={Boolean(customResult)}
                    />
                )}
                {customResult}
                {isMgmSelf && <ResultLotteryTask referralCount={mgmUserGameResultRecords.length} />}
                {/* 
                    要有 game result 才能顯示分享按鈕，同時打API取得邀請碼需要在點擊 share button 才打 [#860rzzcjx]，
                    但另一個情境是你已經邀請過人，那此時邀請人數是來自 referral api，點擊按鈕再打API就太晚了，沒點擊按鈕就需要顯示已經邀請人數，
                    所以會用 mgmUserGameResultRecords 當作已經邀請人數
                */}
                <div css={footerStyle}>
                    {sponsorSlotEnabled && (
                        <ResultPageFroalaView isEditor={false} content={sponsorSlotFroalaEditor} />
                    )}
                    <ResultFooter propsReferralCount={mgmUserGameResultRecords.length} />
                </div>
            </div>
        </>
    );
}

export default ResultPage;

const wrapperStyle = css`
    position: relative;
`;

const footerStyle = css`
    padding: 0 16px;
`;
